


































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import Upload from "@/models/Upload";
import {Action, State} from "vuex-class";
import Metadata from "@/models/Metadata";
import AccountDataAES from "@/util/accountDataAES";
import store from "@/store";
import Base64Encoder from "@/util/base64encoder";
import KeyUtility from "@/util/keyUtility";
import dayjs from "@/util/dayjs";
import getFileSizeHumanReadable from '@/util/file-size';
import featureFlags from "@/util/featureFlags";
import EncryptedFile from "@/models/EncryptedFile";
import LoadingButton from "@/components/LoadingButton.vue";
import AnimatedInput from "@/components/AnimatedInput.vue";
import {Modal} from "bootstrap-vue";
// @ts-ignore Somehow installing @types/vue2-datepicker breaks all typescript
import DatePicker from 'vue2-datepicker';
import PricingCalculator from "@/util/pricingCalculator";
import TransferInteraction from "@/models/TransferInteraction";
import EncryptedTransferInteraction from "@/models/EncryptedTransferInteraction";
import InteractionAdapter from "@/adapters/interaction";

@Component({
  components: {AnimatedInput, LoadingButton, DatePicker},
})
export default class UploadListItem extends Vue {

  @Prop(Object) upload!: Upload;
  @State(state => state.account.masterKey) masterKey!: CryptoKey;
  @Action deleteUpload!: (id: string) => Promise<void>;
  @Action changeUploadExpiration!: ({id, newDate}: {id: string, newDate: Date}) => Promise<void>;

  metadata: Metadata | null = null;
  fileLink: string = "";
  failedDecyption: boolean = false;
  loading: boolean = true;
  encryptedInteractions: EncryptedTransferInteraction[] = [];
  decryptedInteractions: TransferInteraction[] = [];
  interactionModalTitle: string = "";

  fileApprovals: {[key: number]: {verdict: boolean | null , yes: number, no: number}} = {};
  selectedFileForModal: number = -1;

  expirationDate: Date | null = null;

  get formattedCreationDate(): string {
    const date = dayjs(this.upload.created);
    return date.format('dddd, DD. MMMM YYYY [um] HH:mm');
  }

  get formattedExpirationDate(): string {
    const date = dayjs(this.upload.expiry);
    return date.format('dddd, DD. MMMM YYYY [um] HH:mm');
  }

  get fileSizeSummed(): string {
    if (this.metadata) {
      let size = 0;
      for (const file of this.metadata.files) {
        size += file.size;
      }
      return getFileSizeHumanReadable(size);
    } else {
      return "Dateigröße wird entschlüsselt...";
    }
  }

  get fileCount(): number {
    if (this.metadata) {
      return this.metadata.files.length;
    } else {
      return 0;
    }
  }

  get files(): EncryptedFile[] {
    if (this.metadata) {
      return this.metadata.files;
    } else {
      return [];
    }
  }

  fileName(fileIdx: number): string {
    try {
      return this.files[fileIdx].name;
    } catch (e) {
      return "";
    }
  }

  formatDateString(dateString: string): string {
    const date = dayjs(dateString);
    return date.format('dddd, DD. MMMM YYYY [um] HH:mm');
  }

  humanReadableFileSize(filesize: number) {
    return getFileSizeHumanReadable(filesize);
  }

  openModal() {
    (this.$refs.expirymodal as Modal).show();
  }

  closeModal() {
    (this.$refs.expirymodal as Modal).hide();
  }

  resetModal() {
    this.expirationDate = null;
  }


  disabledBeforeToday(date: Date) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return date < today;
  }


  get estimatedTokenCostForExpiryChange(): number {
    if (this.expirationDate === null || this.metadata === null) {
      return 0;
    } else {
      return PricingCalculator.getEstimatedTokenCostOfUploadWithTimestamps(this.metadata.files, this.upload.expiry, this.expirationDate);
    }
  }

  async changeExpirationDate() {
    if (this.expirationDate === null) {
      this.$toast.error("Kein Ablaufdatum gesetzt.");
      return;
    }

    try {
      await this.changeUploadExpiration({id: this.upload.id, newDate: this.expirationDate as Date});
      this.$toast.success("Ablaufdatum wurde angepasst.");
    } catch (e) {
      this.$toast.error("Ablaufdatum konnte nicht angepasst werden.");
    } finally {
      this.closeModal();
      this.resetModal();
    }
  }

  async getLink(): Promise<string> {

    if (!this.metadata) {
      return "Link nicht verfügbar";
    }

    const accountEncryption: AccountDataAES = await AccountDataAES.fromAccountData(store.state.account.masterKey, store.state.account.accountData);
    const metaKeyBase64: string = await accountEncryption.decryptStringFromBase64Encoded(
        this.upload.secretEncrypted, Base64Encoder.stringToBytes(this.upload.secretEncryptedIv));

    let neededForDecryption: string = "";

    if (this.upload.passwordProtected) {
      neededForDecryption = this.metadata.saltAsBase64;
    } else {
      neededForDecryption = metaKeyBase64;
    }

    const link: string = featureFlags.frontendBaseUrl +
        "/download/" + this.upload.id + '#' + encodeURIComponent(neededForDecryption);
    return link;
  }

  async deleteFile(): Promise<void> {
    const willDelete: boolean | null = await this.$swal({
      title: "Sind sie sicher?",
      text: "Wenn Du die Datei löscht, gibt es keine Möglicheit, sie wieder herzustellen!",
      icon: "warning",
      buttons: ["Nein, zurück", "Ja, Löschen"],
      dangerMode: true,
    });

    if (willDelete) {
      try {
        await this.deleteUpload(this.upload.id);
        this.$toast.success("Datei gelöscht");
      } catch (e) {
        this.$toast.error("Datei konnte nicht gelöscht werden");
      }
    }
  }

  async copyLinkToClipboard(): Promise<void> {
    const copyText: HTMLInputElement = document.createElement("input");
    document.body.appendChild(copyText);
    copyText.value = this.fileLink;
    copyText.select();
    document.execCommand("copy");
    document.body.removeChild(copyText);
    this.$toast.success('Link wurde in die Zwischenablage kopiert.');
  }

  @Watch('upload')
  async encryptValuesIntoComponent(): Promise<void> {
    try {
      const accountEncryption: AccountDataAES = await AccountDataAES.fromAccountData(store.state.account.masterKey, store.state.account.accountData);
      const metaKeyBase64: string = await accountEncryption.decryptStringFromBase64Encoded(
          this.upload.secretEncrypted, Base64Encoder.stringToBytes(this.upload.secretEncryptedIv));
      const metaKey: CryptoKey = await KeyUtility.loadKeyFromBase64(metaKeyBase64);
      const meta: Metadata = await Metadata.fromEncryptedBytesAsBase64(metaKey, Base64Encoder.stringToBytes(this.upload.iv), this.upload.encryptedMetadata);
      this.metadata = meta;
      this.fileLink = await this.getLink();
      this.failedDecyption = false;
    } catch (e) {
      this.failedDecyption = true;
      this.$log.error("Failed to decrypt values of upload", e);
    } finally {
      this.loading = false;
    }
  }

  async downloadEncryptedInteractions(): Promise<void> {
    try {
      const adapter = new InteractionAdapter();
      const serverFetched: EncryptedTransferInteraction[] = await adapter.getInteractionsForUpload(this.upload.id);
      this.encryptedInteractions.push(...serverFetched);
    } catch (e) {
      this.$log.error("Failed to download interactions of upload", e);
    }
  }

  get downloadInteractionIsEnabled(): boolean {
    return this.metadata && this.metadata.interactionConfiguration && this.metadata.interactionConfiguration.needsNameEntered || false;
  }

  get encryptedDownloadInteractions(): EncryptedTransferInteraction[] {
    return this.encryptedInteractions.filter((interaction) => interaction.kind === 'download');
  }

  get downloadCommentsAreEnabled(): boolean {
    return this.metadata && this.metadata.interactionConfiguration && this.metadata.interactionConfiguration.enableComments !== "disabled" || false;
  }

  get encryptedCommentInteractions(): EncryptedTransferInteraction[] {
    return this.encryptedInteractions.filter((interaction) => interaction.kind === 'comment');
  }

  get downloadApprovalIsEnabled(): boolean {
    return this.metadata && this.metadata.interactionConfiguration && this.metadata.interactionConfiguration.approvalEnabled || false;
  }

  get encryptedApprovalInteractions(): EncryptedTransferInteraction[] {
    return this.encryptedInteractions.filter((interaction) => interaction.kind === 'approval');
  }

  async decryptAllInteractionsOfType(interactionType: string): Promise<TransferInteraction[]> {
    const encryptedInteractions: EncryptedTransferInteraction[] = [];
    const decryptedInteractions: TransferInteraction[] = [];

    if (this.metadata && this.metadata.interactionConfiguration && this.metadata.interactionConfiguration.symmetricInteractionKey) {
      const interactionKey: CryptoKey = await KeyUtility.loadKeyFromBase64(this.metadata.interactionConfiguration.symmetricInteractionKey);

      switch (interactionType) {
        case 'download':
          encryptedInteractions.push(...this.encryptedDownloadInteractions);
          break;
        case 'comment':
          encryptedInteractions.push(...this.encryptedCommentInteractions);
          break;
        case 'approval':
          encryptedInteractions.push(...this.encryptedApprovalInteractions);
          break;
      }

      for (const encryptedInteraction of encryptedInteractions) {
        const decrypted = await TransferInteraction.FROM_ENCRYPTED(encryptedInteraction, interactionKey);
        decryptedInteractions.push(decrypted);
      }
    }
    return decryptedInteractions;
  }

  get filteredAndSortedDecryptedInterations(): TransferInteraction[] {
    const filtered = this.decryptedInteractions.filter( (interaction: TransferInteraction) => {
      if (this.selectedFileForModal === -1) {
        return true;
      } else {
        return interaction.fileIdx === this.selectedFileForModal;
      }
    });
    return filtered.sort((a, b) => {
      if (a.created === b.created) {
        return 0;
      }
      return dayjs(a.created).isAfter(dayjs(b.created)) ? -1 : 1;
    });
  }

  get fileDropdownOptions(): Array<{value: number, text: string}> {
    const result = [];
    result.push({value: -1, text: "Alle Dateien"});
    for (let i = 0; i < this.files.length; i++) {
      result.push({value: i, text: this.files[i].name});
    }
    return result;
  }

  async computeApprovalsOfFiles() {
    const encryptedFiles = this.files;
    const interactions = await this.decryptAllInteractionsOfType('approval');
    const approvals: {[key: number]: {verdict: boolean | null, yes: number, no: number}} = {};
    for (let i = 0; i < encryptedFiles.length; i++) {
      //@ts-ignore
      const yes: number = interactions.filter((interaction: TransferInteraction) => interaction.fileIdx === i && interaction.data.approved === true).length;
      //@ts-ignore
      const no: number = interactions.filter((interaction: TransferInteraction) => interaction.fileIdx === i && interaction.data.approved === false).length;
      const verdict: boolean | null = no > 0 ? (yes > 0 ? null : false) : (yes > 0);
      approvals[i] = {
        verdict,
        yes,
        no,
      };
    }
    this.fileApprovals = approvals;
  }

  async openInteractionModalForType(interactionType: string): Promise<void> {

      const decryptedInteractions: TransferInteraction[] = await this.decryptAllInteractionsOfType(interactionType);

      switch (interactionType) {
        case 'download':
          this.interactionModalTitle = "Downloads";
          break;
        case 'comment':
          this.interactionModalTitle = "Kommentare";
          break;
        case 'approval':
          this.interactionModalTitle = "Freigaben";
          break;
      }

      this.decryptedInteractions.push(...decryptedInteractions);
      this.selectedFileForModal = -1;
      (this.$refs.interactionmodal as Modal).show();
      return;
  }

  closeInteractionModal() {
    (this.$refs.interactionmodal as Modal).hide();
    this.decryptedInteractions = [];
  }

  created(): void {
    this.encryptValuesIntoComponent();
    this.downloadEncryptedInteractions().then(() => {
      this.computeApprovalsOfFiles();
    });

  }
}
